import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { setApgarRespirationOptions } from '../store/options.actions'

import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getApgarRespirationOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const apgarRespiration: IOptionsResponse = yield call([vitalsService, vitalsService.getApgarRespiration])
    const { entity } = apgarRespiration
    yield put(setApgarRespirationOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getApgarRespirationOptions() error: ${e}`))
  }
}

export function* getApgarRespirationOptionsSaga() {
  yield takeLatest(ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS, getApgarRespirationOptions)
}
